export default "__VITE_ASSET__d16affe0__"